import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=e8a82cf8"
import script from "./attachments.vue?vue&type=script&lang=js"
export * from "./attachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports